export default __webpack_public_path__ + "static/media/thumbnail-img.3e2778e4.svg";